export const hidePricing = () => {
    return window.location.href.includes("?free")
}